import { InjectionToken } from "@angular/core";
import { EnvConfig } from "../models/env-config";

export const ENV_FILE_TOKEN = new InjectionToken<EnvConfig>("ENV_FILE_TOKEN");
